import React from "react";
import { Corner } from "../../../assets";

const Input = ({type, id, placeholder, style, corner, mb}) => {
    console.log(type);
  return (
    <div className={mb ? 'relative' : 'mb-6 relative'}>
      <img className={`${corner ? 'hidden' : 'absolute top-0 right-0'}`} src={Corner} alt="corner" />
      <input
        type={type}
        id={id}
        className={`${style} bg-white border border-gray-300 focus:ring-blue-500 focus:border-blue-500 block shadow-inputShadow outline-none w-full dark:bg-gray-inputGray border-none dark:placeholder-gray-400 dark:text-gray-400 dark:focus:ring-blue-500 dark:focus:border-blue-500`}
        placeholder={placeholder}
        required
      />
    </div>
  );
};

export default Input;
